import './Dot.scss';

export type DotProps = {
  color: string;
  borderRadius?: string;
  size?: 'small' | 'large';
};

const Dot = ({ color, borderRadius = '50%', size = 'small' }: DotProps) => {
  return (
    <>
      {color && (
        <div
          className='Dot-container'
          style={{
            borderColor: color,
            borderRadius: borderRadius,
            width: size === 'small' ? '10px' : '16px',
            height: size === 'small' ? '10px' : '16px',
          }}
        >
          <div className='Dot-inner' style={{ background: color, borderRadius: borderRadius }}></div>
        </div>
      )}
    </>
  );
};

export default Dot;
